import React from 'react';
import Icon from '../../components/AppIcon';

const inventarios = [
  {
    name: 'Inventario Distribución',
    icon: '🚚',
    color: '#60A5FA',
    borderColor: 'rgba(96,165,250,0.25)',
    bgColor: 'rgba(96,165,250,0.06)',
    items: ['Productos', 'Entradas', 'Salidas', 'Ajustes', 'Stock Actual', 'Alertas', 'Valoración'],
  },
  {
    name: 'Inventario Tienda',
    icon: '🏪',
    color: '#34D399',
    borderColor: 'rgba(52,211,153,0.25)',
    bgColor: 'rgba(52,211,153,0.06)',
    items: ['Productos', 'Entradas', 'Salidas', 'Ajustes', 'Stock Actual', 'Alertas', 'Valoración'],
  },
];

const kpis = [
  { label: 'Stock Total Distribución', icon: 'Package', color: '#60A5FA' },
  { label: 'Stock Total Tienda', icon: 'ShoppingBag', color: '#34D399' },
  { label: 'Valoración Total', icon: 'TrendingUp', color: '#D6EF4E' },
  { label: 'Alertas Stock Mínimo', icon: 'AlertTriangle', color: '#F87171' },
];

const ERPInventario = () => (
  <div className="min-h-screen px-4 py-8 md:px-8" style={{ background: 'linear-gradient(135deg, #0A0A0A 0%, #111111 50%, #0D0D0D 100%)' }}>
    {/* Header */}
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(214,239,78,0.10)', border: '1px solid rgba(214,239,78,0.25)' }}>
          <Icon name="Package" size={20} className="text-[#D6EF4E]" />
        </div>
        <div>
          <h1 className="font-oranienbaum font-bold text-white text-3xl tracking-wide">Inventario</h1>
          <p className="font-oranienbaum text-white/40 text-sm">ERP Empresarial · Gestión de Stock</p>
        </div>
      </div>
      <div className="mt-3 ml-[52px] h-px w-32" style={{ background: 'linear-gradient(90deg, #D6EF4E 0%, transparent 100%)' }} />
    </div>

    {/* Status badge */}
    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-8 ml-[52px]" style={{ background: 'rgba(214,239,78,0.06)', border: '1px solid rgba(214,239,78,0.15)' }}>
      <div className="w-1.5 h-1.5 rounded-full bg-[#D6EF4E] animate-pulse" />
      <span className="font-oranienbaum text-[#D6EF4E]/70 text-xs tracking-widest uppercase">Módulo en construcción · Arquitectura preparada</span>
    </div>

    {/* KPIs */}
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
      {kpis?.map((kpi, i) => (
        <div key={i} className="rounded-2xl p-5 flex flex-col gap-3" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}>
          <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: `${kpi?.color}15`, border: `1px solid ${kpi?.color}30` }}>
            <Icon name={kpi?.icon} size={18} style={{ color: kpi?.color }} />
          </div>
          <div className="h-6 w-20 rounded-md" style={{ background: 'rgba(255,255,255,0.05)' }} />
          <p className="font-oranienbaum text-white/50 text-xs">{kpi?.label}</p>
        </div>
      ))}
    </div>

    {/* Inventarios independientes */}
    <div className="flex items-center gap-3 mb-5">
      <div className="h-px flex-1" style={{ background: 'rgba(255,255,255,0.06)' }} />
      <h2 className="font-oranienbaum text-white/50 text-xs uppercase tracking-widest px-3">Inventarios Independientes</h2>
      <div className="h-px flex-1" style={{ background: 'rgba(255,255,255,0.06)' }} />
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
      {inventarios?.map((inv, i) => (
        <div key={i} className="rounded-2xl p-6 flex flex-col gap-4" style={{ background: `linear-gradient(135deg, ${inv?.bgColor} 0%, rgba(17,17,17,0.97) 100%)`, border: `1px solid ${inv?.borderColor}` }}>
          <div className="flex items-center gap-3">
            <span className="text-2xl">{inv?.icon}</span>
            <div>
              <h3 className="font-oranienbaum font-bold text-white text-lg">{inv?.name}</h3>
              <span className="font-oranienbaum text-[10px] px-2 py-0.5 rounded-full uppercase tracking-widest" style={{ background: 'rgba(255,255,255,0.04)', color: 'rgba(255,255,255,0.25)', border: '1px solid rgba(255,255,255,0.08)' }}>Próximamente</span>
            </div>
          </div>
          <div className="h-px w-full" style={{ background: `linear-gradient(90deg, ${inv?.color}30 0%, transparent 100%)` }} />
          <div className="grid grid-cols-2 gap-2">
            {inv?.items?.map((item, j) => (
              <div key={j} className="flex items-center gap-2 px-3 py-2 rounded-lg" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
                <div className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: inv?.color, opacity: 0.5 }} />
                <span className="font-oranienbaum text-white/50 text-xs">{item}</span>
              </div>
            ))}
          </div>
          <div className="mt-2 p-3 rounded-xl" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.05)' }}>
            <p className="font-oranienbaum text-white/30 text-xs text-center">Stock independiente · Sin mezcla de valoración</p>
          </div>
        </div>
      ))}
    </div>

    {/* Relación con Sala de Corte */}
    <div className="rounded-2xl p-6" style={{ background: 'rgba(214,239,78,0.04)', border: '1px solid rgba(214,239,78,0.12)' }}>
      <div className="flex items-center gap-3 mb-4">
        <span className="text-xl">🔪</span>
        <h3 className="font-oranienbaum font-bold text-[#D6EF4E]/80 text-base">Relación con Sala de Corte</h3>
      </div>
      <p className="font-oranienbaum text-white/40 text-sm leading-relaxed">
        La Sala de Corte no tiene inventario propio. Consume producto desde Inventario Distribución o Inventario Tienda. Cada loncheado registra el departamento propietario del producto para imputar correctamente la rentabilidad.
      </p>
    </div>
  </div>
);

export default ERPInventario;
